export function buildLitmosRedirectPageURL() {
  return '/litmos-redirect'
}
